const SITE_ORIGIN = 'https://enjoy-toys.store';

/**
 * Медиа с API: полный URL (S3 и т.п.) или относительный путь (/uploads/...).
 * Для Open Graph, RSS, sitemap, JSON-LD не склеиваем домен с уже абсолютным URL.
 */
export const resolvePublicMediaUrl = (
  url: string | undefined | null,
): string | undefined => {
  if (url == null || typeof url !== 'string') return undefined;
  const u = url.trim();
  if (!u) return undefined;
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('//')) return `https:${u}`;
  return `${SITE_ORIGIN}${u.startsWith('/') ? '' : '/'}${u}`;
};
